export function isTimeOff(event) {
    return event.key.startsWith('TimeOff');
}
;
export function isVisit(event) {
    const keyPrefixes = ["Inspection" /* VisitType.INSPECTION_PRIMARY_VISIT */, "Visit" /* VisitType.SERVICE_VISIT */];
    return keyPrefixes.some((prefix) => event.key.startsWith(prefix));
}
;
